module.exports = __webpack_public_path__ + "static/media/bottom_referral.2a3a7cf5.svg";